<template>
  <div :class="['cursor', { hover: hover, hide: hideCursor }]">
    <div class="pointer" :style="pointerStyle"></div>
    <div class="circle" :style="circleStyle"></div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.cursor {
  backface-visibility: hidden;
  pointer-events: none;
  transition: opacity 0.25s;
  user-select: none;

  .pointer {
    background: $secondary;
    border-radius: 50%;
    height: 50px;
    left: 0;
    mix-blend-mode: hue;
    opacity: 0.85;
    position: fixed;
    top: 0;
    width: 50px;
    will-change: transform;
    z-index: 1100;
  }

  .circle {
    border-radius: 50%;
    border: solid 1px $secondary;
    height: 60px;
    left: 0;
    mix-blend-mode: hue;
    opacity: 0.85;
    position: fixed;
    top: 0;
    width: 60px;
    will-change: transform;
    z-index: 1100;
  }

  &.hide {
    opacity: 0;
  }
}
</style>

<script>
export default {
  data() {
    return {
      hideCursor: true,
      hover: false,
      mouse: {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2
      },
      pointer: {
        scale: 1 / 5,
        size: 50,
        x: window.innerWidth / 2,
        y: window.innerHeight / 2
      },
      circle: {
        scale: 1 / 2,
        size: 60,
        x: window.innerWidth / 2,
        y: window.innerHeight / 2
      }
    };
  },

  computed: {
    circleStyle() {
      return `transform: translateX(${this.circle.x}px) translateY(${this.circle.y}px) scale(${this.circle.scale});`;
    },

    pointerStyle() {
      return `transform: translateX(${this.pointer.x}px) translateY(${this.pointer.y}px) scale(${this.pointer.scale});`;
    }
  },

  methods: {
    lerp(start, end, amount) {
      return (1 - amount) * start + amount * end;
    },

    updateCursor() {
      var pointerScaleRatio = 1 / 5,
        circleScaleRatio = 1 / 2;

      this.pointer.scale = this.lerp(this.pointer.scale, this.hover ? 1 : pointerScaleRatio, 0.15);
      this.pointer.x = this.lerp(this.pointer.x, this.mouse.x - this.pointer.size / 2, 0.75);
      this.pointer.y = this.lerp(this.pointer.y, this.mouse.y - this.pointer.size / 2, 0.75);

      this.circle.scale = this.lerp(this.circle.scale, this.hover ? 1 : circleScaleRatio, 0.15);
      this.circle.x = this.lerp(this.circle.x, this.mouse.x - this.circle.size / 2, 0.15);
      this.circle.y = this.lerp(this.circle.y, this.mouse.y - this.circle.size / 2, 0.15);

      requestAnimationFrame(this.updateCursor);
    },

    handleMove(e) {
      var targetElements = ['A', 'BUTTON'],
        hoverElements = Array.from(document.querySelectorAll(':hover')).map((element) => element.tagName);

      this.mouse.x = e.clientX;
      this.mouse.y = e.clientY;
      this.hover = targetElements.some((element) => hoverElements.includes(element));
    }
  },

  created() {
    window.addEventListener('mousemove', this.handleMove);
  },

  beforeUnmount() {
    window.removeEventListener('mousemove', this.handleMove);
  },

  mounted() {
    document.addEventListener('mouseleave', () => {
      this.hideCursor = true;
    });

    document.addEventListener('mouseenter', () => {
      this.hideCursor = false;
    });

    this.updateCursor();
  }
};
</script>
